import { Pipe, PipeTransform } from "@angular/core";
import { StringHelper } from "@tylertech/shared-module";

@Pipe({ name: "abbreviateNumber" })
export class AbbreviateNumberPipe implements PipeTransform
{
    transform(value: NumericString | CurrencyString): string
    {
        return formatAbbreviatedNumber(value);
    }
}

export type NumericString = `${number}` | `-${number}`;
export type CurrencyString = `$${number}` | `-$${number}`;

export function formatAbbreviatedNumber(value: NumericString | CurrencyString, decimalPlaces?: number): string;
/**
 * @deprecated Make sure you are passing in a NumericString or a CurrencyString
 */
export function formatAbbreviatedNumber(value: string, decimalPlaces?: number): string;
export function formatAbbreviatedNumber(value: string, decimalPlaces: number = 2): string
{
    let fixedValue: string;

    const negative = value.indexOf("-") > -1;
    const currency = value.indexOf("$") > -1;

    const numericValue = StringHelper.parseNumber(value);
    if (numericValue > -1 && numericValue < 1 && numericValue !== 0)
    {
        fixedValue = numericValue.toFixed(3);
    }
    else if (numericValue > -10 && numericValue < 10)
    {
        fixedValue = numericValue.toFixed(2);
    }
    else
    {
        fixedValue = numericValue.toFixed(0);
    }

    // 2 decimal places => 100, 3 => 1000, etc
    decimalPlaces = Math.pow(10, decimalPlaces);

    fixedValue = fixedValue.replace(/[$,-]/g, "");

    let calcNumber = parseFloat(fixedValue);
    if (isNaN(calcNumber))
    {
        return fixedValue;
    }

    // Enumerate inputNumber abbreviations
    const abbrev = ["k", "m", "b", "t"];

    // Go through the array backwards, so we do the largest first
    for (let i = abbrev.length - 1; i >= 0; i--)
    {
        // Convert array index to "1000", "1000000", etc
        const size = Math.pow(10, (i + 1) * 3);

        // If the inputNumber is bigger or equal do the abbreviation
        if (size <= calcNumber)
        {
            // Here, we multiply by decimalPlaces, round, and then divide by decimalPlaces.
            // This gives us nice rounding to a particular decimal place.
            calcNumber = Math.round((calcNumber * decimalPlaces) / size) / decimalPlaces;

            // Handle special case where we round up to the next abbreviation
            if (calcNumber === 1000 && i < abbrev.length - 1)
            {
                calcNumber = 1;
                i++;
            }

            fixedValue = calcNumber.toString();

            // Add the letter for the abbreviation
            fixedValue = fixedValue.toString() + abbrev[i];

            // We are done... stop
            break;
        }
    }

    if (currency)
    {
        fixedValue = `$${fixedValue}`;
    }

    if (negative)
    {
        fixedValue = `-${fixedValue}`;
    }

    return fixedValue;
}
